export const ACTION_TYPE = {
  PROCESS_REQUEST: 'PROCESS_REQUEST',
  PROCESS_REQUEST_SUCCESS: 'PROCESS_REQUEST_SUCCESS',
  PROCESS_SET_APPLIED: 'PROCESS_SET_APPLIED',
  PROCESS_APPLY_FORM_SHOW: 'PROCESS_APPLY_FORM_SHOW',
  PROCESS_APPLY_FORM_HIDE: 'PROCESS_APPLY_FORM_HID',
  APPLY_BUTTON_DISABLE: 'APPLY_BUTTON_DISABLE',
  APPLY_BUTTON_ENABLE: 'APPLY_BUTTON_ENABLE',
};

export const processRequestData = () => ({
  type: ACTION_TYPE.PROCESS_REQUEST,
});

export const processSetData = process => ({
  type: ACTION_TYPE.PROCESS_REQUEST_SUCCESS,
  data: { process },
});

export const processSetApplied = isApplied => ({
  type: ACTION_TYPE.PROCESS_SET_APPLIED,
  data: { isApplied },
});

export const setFormVisible = isVisible =>
  isVisible
    ? {
        type: ACTION_TYPE.PROCESS_APPLY_FORM_SHOW,
      }
    : {
        type: ACTION_TYPE.PROCESS_APPLY_FORM_HIDE,
      };

export const setApplyButtonEnabled = isEnabled =>
  isEnabled
    ? {
        type: ACTION_TYPE.APPLY_BUTTON_ENABLE,
      }
    : {
        type: ACTION_TYPE.APPLY_BUTTON_DISABLE,
      };

export const action = {
  processRequestData,
  processSetData,
  processSetApplied,
  setFormVisible,
  setApplyButtonEnabled,
};
